define('modules/private/view-mdReminders',['require','exports','module','backbone','react','react-dom','mdremindersjs'],function (require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
      React = require('react'),
      ReactDOM = require('react-dom'),
      MDReminders = require('mdremindersjs');

  var MDRemindersJS = Backbone.View.extend({
    initialize: function (options) {
      this.options = options;
      this.reminderData = options.reminderData;
    },

    render: function () {
      ReactDOM.render(
          React.createElement(
              MDReminders,
              this.reminderData
          ),
          document.getElementById('md__reminders')
      );
    }
  });

  module.exports = MDRemindersJS;
});

